/* ==========================================================================
   Zondela Team Directory — filtros dinámicos + modal de perfil
   - Filtrado sin recarga con transición escalonada
   - Modal accesible (<dialog>) con foco, ESC y clic en backdrop
   - Soporte para el editor de temas (shopify:section:load)
   - Respeta prefers-reduced-motion. Sin librerías externas.
   ========================================================================== */
(function () {
  'use strict';

  var ROOT_SELECTOR = '[data-ztd-root]';

  /* ----------------------------- Filtrado -------------------------------- */

  function applyFilter(root, category) {
    var grid = root.querySelector('[data-ztd-grid]');
    if (!grid) return;

    var items = grid.querySelectorAll('.ztd__item');
    var visible = 0;

    for (var i = 0; i < items.length; i++) {
      var item = items[i];
      var match = item.getAttribute('data-category') === category;

      if (match) {
        item.hidden = false;
        item.style.setProperty('--ztd-i', visible);
        // Reinicia la animación de entrada
        item.classList.remove('ztd__item--in');
        // Fuerza reflow para reiniciar la transición
        void item.offsetWidth;
        item.classList.add('ztd__item--in');
        visible++;
      } else {
        item.hidden = true;
        item.classList.remove('ztd__item--in');
      }
    }

    // Estado de las pills
    var pills = root.querySelectorAll('[data-ztd-filter]');
    for (var p = 0; p < pills.length; p++) {
      var on = pills[p].getAttribute('data-ztd-filter') === category;
      pills[p].classList.toggle('ztd__pill--active', on);
      pills[p].setAttribute('aria-pressed', on ? 'true' : 'false');
    }

    // Estado vacío
    var empty = root.querySelector('[data-ztd-empty]');
    if (empty) empty.hidden = visible !== 0;

    root.setAttribute('data-active-filter', category);
  }

  /* ------------------------------- Modal --------------------------------- */

  function buildSocial(container, data) {
    var links = [
      {
        url: data.instagram,
        label: 'Instagram',
        icon:
          '<svg viewBox="0 0 24 24" fill="none" aria-hidden="true"><rect x="3" y="3" width="18" height="18" rx="5" stroke="currentColor" stroke-width="1.8"/><circle cx="12" cy="12" r="4" stroke="currentColor" stroke-width="1.8"/><circle cx="17.2" cy="6.8" r="1.2" fill="currentColor"/></svg>'
      },
      {
        url: data.linkedin,
        label: 'LinkedIn',
        icon:
          '<svg viewBox="0 0 24 24" fill="currentColor" aria-hidden="true"><path d="M4.98 3.5A2.5 2.5 0 1 0 5 8.5a2.5 2.5 0 0 0-.02-5ZM3 9h4v12H3V9Zm6 0h3.8v1.7h.05c.53-.95 1.83-1.95 3.77-1.95C20.4 8.75 21 11 21 14.1V21h-4v-6.1c0-1.45-.03-3.3-2.02-3.3-2.02 0-2.33 1.57-2.33 3.2V21H9V9Z"/></svg>'
      },
      {
        url: data.link,
        label: 'Ver más',
        icon:
          '<svg viewBox="0 0 24 24" fill="none" aria-hidden="true"><path d="M10 14L21 3M21 3h-6M21 3v6" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round"/><path d="M21 13v6a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h6" stroke="currentColor" stroke-width="1.8" stroke-linecap="round"/></svg>'
      }
    ];

    var html = '';
    for (var i = 0; i < links.length; i++) {
      var l = links[i];
      if (l.url && l.url.trim() !== '') {
        html +=
          '<a class="ztd__social-link" href="' +
          encodeURI(l.url) +
          '" target="_blank" rel="noopener noreferrer">' +
          l.icon +
          '<span>' +
          l.label +
          '</span></a>';
      }
    }
    container.innerHTML = html;
  }

  function setText(root, sel, value) {
    var el = root.querySelector(sel);
    if (!el) return;
    if (value && value.trim() !== '') {
      el.textContent = value;
      el.hidden = false;
    } else {
      el.textContent = '';
      el.hidden = true;
    }
  }

  function openModal(root, btn) {
    var modal = root.querySelector('[data-ztd-modal]');
    if (!modal) return;

    var d = btn.dataset;

    // Foto / iniciales
    var photo = modal.querySelector('[data-ztd-modal-photo]');
    var initials = modal.querySelector('[data-ztd-modal-initials]');
    if (d.photo && d.photo.trim() !== '') {
      photo.src = d.photo;
      photo.alt = d.name || '';
      photo.style.display = 'block';
      if (initials) initials.style.display = 'none';
    } else {
      photo.removeAttribute('src');
      photo.style.display = 'none';
      if (initials) {
        initials.textContent = d.initials || '';
        initials.style.display = 'flex';
      }
    }

    // Bandera
    var flag = modal.querySelector('[data-ztd-modal-flag]');
    if (flag) {
      if (d.flagImage && d.flagImage.trim() !== '') {
        flag.innerHTML =
          '<img src="' + encodeURI(d.flagImage) + '" alt="" />';
      } else {
        flag.textContent = d.flagEmoji || '';
      }
    }

    setText(modal, '[data-ztd-modal-name]', d.name);
    setText(modal, '[data-ztd-modal-role]', d.role);
    setText(modal, '[data-ztd-modal-country]', d.country);

    var bio = modal.querySelector('[data-ztd-modal-bio]');
    if (bio) bio.textContent = d.bio || '';

    var social = modal.querySelector('[data-ztd-modal-social]');
    if (social) {
      buildSocial(social, {
        instagram: d.instagram,
        linkedin: d.linkedin,
        link: d.link
      });
    }

    modal._returnFocus = btn;

    if (typeof modal.showModal === 'function') {
      modal.showModal();
    } else {
      modal.setAttribute('open', '');
    }

    var closeBtn = modal.querySelector('[data-ztd-close]');
    if (closeBtn) closeBtn.focus();
  }

  function closeModal(modal) {
    if (!modal) return;
    if (typeof modal.close === 'function' && modal.open) {
      modal.close();
    } else {
      modal.removeAttribute('open');
    }
    if (modal._returnFocus) {
      modal._returnFocus.focus();
      modal._returnFocus = null;
    }
  }

  /* ------------------------------- Init ---------------------------------- */

  function initRoot(root) {
    if (root._ztdInit) return;
    root._ztdInit = true;

    root.classList.add('ztd--js');

    // Filtro inicial
    var initial = root.getAttribute('data-default-filter') || 'equipo';
    applyFilter(root, initial);

    // Clic en pills (delegado)
    root.addEventListener('click', function (e) {
      var pill = e.target.closest('[data-ztd-filter]');
      if (pill && root.contains(pill)) {
        var cat = pill.getAttribute('data-ztd-filter');
        if (cat !== root.getAttribute('data-active-filter')) {
          applyFilter(root, cat);
        }
        return;
      }

      var openBtn = e.target.closest('[data-ztd-open]');
      if (openBtn && root.contains(openBtn)) {
        openModal(root, openBtn);
      }
    });

    // Modal: cierre
    var modal = root.querySelector('[data-ztd-modal]');
    if (modal) {
      modal.addEventListener('click', function (e) {
        if (e.target.closest('[data-ztd-close]')) {
          closeModal(modal);
          return;
        }
        // Clic en el backdrop (fuera del contenido)
        if (e.target === modal) {
          closeModal(modal);
        }
      });
      // ESC en navegadores que no lo manejan nativo en <dialog>
      modal.addEventListener('cancel', function () {
        if (modal._returnFocus) {
          modal._returnFocus.focus();
          modal._returnFocus = null;
        }
      });
    }
  }

  function init() {
    var roots = document.querySelectorAll(ROOT_SELECTOR);
    for (var i = 0; i < roots.length; i++) initRoot(roots[i]);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  /* --------------------- Editor de temas de Shopify ---------------------- */

  document.addEventListener('shopify:section:load', function (event) {
    var root = event.target.querySelector(ROOT_SELECTOR);
    if (root) initRoot(root);
  });

  document.addEventListener('shopify:section:select', function (event) {
    var root = event.target.querySelector(ROOT_SELECTOR);
    if (root && !root._ztdInit) initRoot(root);
  });
})();
